import { QueryClient } from "@tanstack/react-query"
import { type GetStaticPropsContext, type InferGetStaticPropsType } from "next"
import { getArticles } from "@/features/blog"
import { getStoryblokLayout, StoryTemplate } from "@/features/storyblok"
import { withStoryProps } from "@/features/storyblok/server"

type BlogPageProps = InferGetStaticPropsType<typeof getStaticProps>

const SECTION_URL = "blog/"

export default function BlogPage({ story }: BlogPageProps) {
    return <StoryTemplate story={story} />
}

BlogPage.getLayout = getStoryblokLayout
BlogPage.messages = [...getStoryblokLayout.messages] as const

type PageQueryParams = {
    categoryId: string
    postId: string
}

export async function getStaticPaths() {
    return getArticles(SECTION_URL)
}

export async function getStaticProps(context: GetStaticPropsContext<PageQueryParams>) {
    const queryClient = new QueryClient()
    const slug = `${SECTION_URL}${context.params?.categoryId}/${context.params?.postId}`

    return withStoryProps({
        slug,
        options: { resolve_relations: "blogPost.author" },
        context,
        queryClient,
        intlNamespaces: BlogPage.messages,
        props: {},
    })
}
